<template>
  <div>
    <div class="nooutline" :style="((height!=null)&&(!resizable))?{ 'height':height,'overflow-y':'auto',width:width }:false" tabindex="0" @keyup.down="selectNext" @keyup.up="selectPrev" @scroll="handleScroll"
         v-infinite-scroll="loadMoreItems" infinite-scroll-distance="10"
    >
      <div v-if="!showEditor">
        <wrapped-component :wrap="resizable">
          <template #wrapper><vue-resizable :style="(height!=null)?('overflow-y:auto'):false" :active="(resizable)?['rb','r','b']:[]" :height="height" :width="width" ref="resizable" @mount="changeSize" @resize:move="changeSize" #wrapper/></template>
          <table class="table table-bordered table-striped table-condensed2" :loading="loading" :key="pagecount" >
            <colgroup>
              <col v-if="tree" :width="10">
              <col v-for="column in visiblecolumns" :key="column.field" :width="(column.width==null)?'*':column.width"/>
            </colgroup>
            <thead>
            <tr class="info" @contextmenu.prevent="openTitleContextMenu">
              <th v-if="tree"></th>
              <th v-for="column in visiblecolumns" :key='column.field' class="tablersticky">{{ column.title }}
                <span v-if="column.sortable" @click="setSortField(column)" class="pull-right"><span v-if="column!=sortfield" class="glyphicon glyphicon-sort tblsorticon"></span>
                            <span v-if="(column==sortfield)&&(sorttype==0)" class="glyphicon glyphicon-sort-by-attributes"></span>
                            <span v-if="(column==sortfield)&&(sorttype==1)" class="glyphicon glyphicon-sort-by-attributes-alt"></span>
                        </span>
              </th>
            </tr>
            <tr v-if="hasfilters">
              <td v-if="tree"></td>
              <td v-for="column in visiblecolumns" :key='column.field' class="tablerstickyfilter">
                <input v-if="column.filter=='input'" class="form-control input-sm" v-model="filters[column.field]" :placeholder="$gettext('Поиск...')"/>
                <span v-if="column.filter=='date'" class='input-group datefilter'>
                            <input class="form-control input-sm" v-model="filters[column.field].from" type="date" :placeholder="$gettext('От')"/>
                            <input class="form-control input-sm" v-model="filters[column.field].to" type="date" :placeholder="$gettext('До')"/>
                        </span>
                <select v-if="column.filter=='select'" class="form-control input-sm" v-model="filters[column.field]">
                  <option value=""></option>
                  <option value="#nodata" v-translate>-Пусто-</option>
                  <option v-for="v in allcolumnvalues(column.field)" :value="v" :key="v">{{ v }}</option>
                </select>
                <select v-if="column.filter=='yesno'" class="form-control input-sm" v-model="filters[column.field]">
                  <option value=""></option>
                  <option value="false" v-translate>Нет</option>
                  <option value="true" v-translate>Да</option>
                </select>
              </td>
            </tr>
            </thead>
            <tbody :class="loading" :key="updateindex">
            <template v-for="item in sorteditems">
            <tr :key="item.__key" :ref="'el_'+item.id" v-bind:selected="(itemSelected!=null)&&(itemSelected.id===item.id)" @click="selectItem(item)" @dblclick="$emit('dblclick',item)" v-bind:rowid="item.id" v-bind:updated="item.__updated" :class="rowclass?rowclass(item):null" @contextmenu.prevent="(contextitems!==null)?openContextMenu(item,$event):null">
              <td v-if="tree">
                <span v-if="(item.children!=null)&&(item.children.length>0)" class="glyphicon" :class="(item.__expanded)?'glyphicon-menu-down':'glyphicon-menu-right'" @click="item.__expanded=(item.__expanded==null)?true:!item.__expanded;pagecount++"></span>
              </td>
              <slot name="templaterow" :item="item" :options="options">
                <td v-for="column in visiblecolumns" :key='column.field' :class="column.class?column.class(item):null">
                    <wrapped-component :wrap="draggable">
                       <template #wrapper><drag :transfer-data="item" :class="draggable?draggable.class:''" @dragend="draggable?draggable.dragend:null" #wrapper>
                         <span v-if="draggable&&draggable.image" slot="image"><slot name="drag.image" :item="item"></slot></span>
                       </drag></template>
                      <span v-if="column.type=='html'" v-html="item[column.field]"></span>
                      <span v-else-if="column.type=='yesno'" :class="item[column.field]?'text-success':'text-danger'">{{ item[column.field]?$gettext('Да'):$gettext('Нет') }}</span>
                      <span v-else-if="column.dateformat">{{ item[column.field] | dateformat(column.dateformat) }}</span>
                      <span v-else-if="column.type=='yesno'" :name="column.field" :item="item">{{ item[column.field]?$gettext('Да'):$gettext('Нет') }}</span>
                      <template v-else><slot :name="column.field" :item="item">{{ item[column.field] }}</slot></template>
                    </wrapped-component>
                </td>
              </slot>
            </tr>
              <slot name="afterrowtemplate" :item="item" :options="options"></slot>
            </template>
            </tbody>
          </table>
        </wrapped-component>
      </div>
      <div v-if="showEditor">
        <div class="pull-left"><btn type="primary" @click="showEditor=false"><span class="glyphicon glyphicon-arrow-left"></span> Вернуться</btn></div>
        <div class="pull-right"><btn type="success" @click="saveContextEditor"><span class="glyphicon glyphicon-ok"></span> Принять</btn></div>
        <h2 class="centered">Редактор таблицы</h2>
        <alert type="danger" v-if="editorError" v-html="editorError"></alert>
        <div>
          <strong class="pull-left">Столбец</strong>
          <strong class="pull-right">Видимость</strong>
        </div><hr/>
        <draggable v-model="sortedcolumns">
          <div class="list-group-item"
               v-for="p in sortedcolumns"
               :key="p.column">
            <strong v-html="(p.title!=null)?p.title:p.column"></strong>
            <span class="pull-right"><toggle v-model="p.visible" :options="{ off:'Нет',offstyle:'danger',on:'Да',onstyle:'success',size:'small' }" title="Видимость"/></span>
          </div>
        </draggable>
      </div>
      <progresser class="tablerprogresser" :completed1="progress" :total1="100" :status="(progresstotal==null)?null:1"></progresser>
    </div>
    <div v-if="options.buttons || options.totalcount" class="tablerfooter" :style="footerStyle">
      <strong v-if="options.totalcount" class="totalcount" :key="pagecount">Всего: {{ items.length }}<i v-if="progresstotal">({{ progresstotal }})</i><span v-if="filteredcount && (filteredcount!=items.length)">, фильтр: {{ filteredcount }}</span>
        <template v-for="column in options.columns" >
          <span v-if="column.total" :key="column.field">, {{ column.title }}: {{ totalsum(column) }} <span v-if="filteredcount && (filteredcount!=items.length)">({{ filteredsum(column) }})</span></span>
        </template>
      </strong>
      <div class="tablerbuttons btn-group">
        <button v-for="button in options.buttons" :key='button.action' class="btn btn-sm" :class="button.class" :disabled="((value===null)&&(button.onitem))||(disabled)" :title="button.hint" v-on:click="callfunc(button.action)">
          <span v-if="button.glyph" class="glyphicon" :class="'glyphicon-'+button.glyph"></span><span v-if="button.title"> {{ button.title }}</span>
        </button>
      </div>
    </div>

    <context v-if="contextitems" ref="tablercontext">
      <li v-for="ci in contextitems" :key="ci.text"><a href="#" @click.prevent="ci.action(contextSelected)">{{ ci.text }}</a></li>
    </context>

    <context ref="titlecontext">
      <li><a href="#" @click.prevent="showContextEditor">Ред.таблицы</a></li>
    </context>
  </div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import VueContext from 'vue-context'
import VueResizable from 'vue-resizable'
import WrappedComponent from 'vue-wrapped-component'
import infiniteScroll from 'vue-infinite-scroll'
import Progresser from './progresser.vue'
import { Alert } from 'uiv'

export default {
  props: ['options','params','disabled','height','value','rowclass','resizable','width','scrollable','draggable','tree'],
  data:function(){
    return {
      items:[],
      filters:Object.assign({},this.filters,this.options.columns.reduce((a,d)=>{ if (d.filter!=null) a[d.field]=(d.filter=='date')?{ from:null,to:null }:""; return a;},{})),
      itemSelected:null,
      loading:false,
      pagecount:0,
      progress:0,
      progresstotal:null,
      filteredcount:0,
      contextSelected:null,
      resizewidth:null,
      sortfield:null,
      sorttype:null,
      dispcount:100,
      updateindex:0,
      showEditor:false,
      editorError:null,
      sortedcolumns:[],
      visiblecolumns:[],
      refreshing:false
    }
  },
  computed:{
    hasfilters:function(){
      return this.options.columns.reduce( (hf,el)=> (hf||(el.filter!=null)),false);
    },
    contextitems:function(){
      if (this.options.context!=null) return this.options.context;
      if (this.options.buttons==null) return null;
      var c=this.options.buttons.map(b=>{  return { text:((b.title==null)?b.hint:b.title), action:b.action };});
      return c;
    },
    footerStyle:function(){
      if (this.resizewidth!=null)
        return "--width:"+this.resizewidth+"px";
      else
        return "";
    },
    sorteditems(){
      if (this.items==null) return [];
      let res=(this.hasfilters)?(this.items.filter(this.isRowFiltered)):[...this.items];
      this.updateindex;this.pagecount;
      if (this.tree) return this.treeItems(this.items);
      if (this.sortfield!=null) res.sort(this.sortCompare);
      return res.filter((d,i)=>(i<=this.dispcount));
    },
  },
  methods:{
    selectItem:function(item){
      if ((this.options!=null)&&(this.options.notSelectable)) { return this.$emit("select",item); }
      this.itemSelected=item;
      this.$emit("select",item);
      this.$emit("input",item);
    },
    fetchData:async function(refresh){
      if (this.options.query==null)
      {
        this.items=this.params;
        this.loading=false;
        return;
      }
      this.refreshing=refresh;
      this.$emit('before-load');
      var vars=new FormData();
      vars.set('actiondata',this.options.query);
      for(var prop in this.params)
      {
        vars.set(prop,this.params[prop]);
        if ((this.options.nullparam!=1)&&(this.params[prop]==null))
        {
          this.items=[];
          return;
        }
      }
      if (!this.options.stream)
      {
        this.dispcount=100;
        await axios.post("headless.php?actiondata="+this.options.query,vars).then((jd)=>{
          var selExists=false;
          jd.data.map((d)=>{
            d.__key=d.id;
            if ((this.itemSelected!=null)&&(d.id==this.itemSelected.id))
            {
              selExists=true;
              this.$emit("input",d);
            }
            return d;
          });
          if (!selExists){
            this.itemSelected=null;
            this.$emit("input",null);
          }
          this.items=jd.data;
          this.loading=false;
//                        for(var i in this.filters){ this.filters[i]="";};
          this.$emit('load');
        });
      }
      else
      {
        await axios.post("headless.php?action=registerQuery&query="+this.options.query,this.params).then((code)=>{
          var es=new EventSource("headless.php?action=fetchQuery&id="+code.data);
          es.tabler=this;
          this.code=code.data;
          this.pagecount=false;
          this.dispcount=100;
          this.progress=0;
          this.$emit("onprogress",0);
          es.onmessage=function(event)
          {
            if ((event.lastEventId==="0")||(this.tabler.loading))
            {
              if (!this.tabler.refreshing)
                  this.tabler.items=[];
              else
              {
                 this.tabler.items.forEach(a=>{
                   a.__todelete=true;
                 });
              }
//              this.tabler.filters={};
              this.tabler.loading=false;
            }
            var data=JSON.parse(event.data);
            this.tabler.progress=data.progress;
            if (data.total!=null) this.tabler.progresstotal=data.total;
            console.log("this code:"+this.tabler.code+",Tabler code:"+data.code);
            if ((data.code!=null)&&(data.code!=this.tabler.code)) {
              this.close();
              return;
            }
            if (data.data!=null)
            {
              var data1=data.data.map((d)=>{
                d.__key=d.id;
                if ((this.tabler.itemSelected!=null)&&(d.id==this.tabler.itemSelected.id))
                {
                  this.tabler.$emit("input",d);
                }
                return d;
              });
            }
            else
              var data1=[];
            if (!this.tabler.refreshing)
                Array.prototype.push.apply(this.tabler.items, data1);
            else {
                let data2=[];
                data1.forEach(a=>{
                   let existing=this.tabler.items.filter(b=>(b.__key==a.__key));
                   if (existing.length==0)
                     data2.push(a);
                   else {
                     existing[0].__todelete=null;
                     for(let fi in a) {
                        if (a[fi]!=existing[0][fi])
                          existing[0][fi]=a[fi];
                     }
                   }
                });
              Array.prototype.push.apply(this.tabler.items, data2);
            }
            this.tabler.updateindex++;
            if (event.lastEventId==="-1")
            {
              this.close();
              this.tabler.progresstotal=null;
              this.tabler.$emit('load',this.tabler.items);
              this.tabler.$emit("onprogress",null);
              if ((this.tabler.value!=null)&&(this.tabler.value!=""))
              {
                let it=this.tabler.items.filter(a=>(a.id==this.tabler.value));
                if (it.length>0)
                  this.tabler.itemSelected=it[0];
              }
              if (this.tabler.refreshing)
              {
                this.tabler.items=this.tabler.items.filter(a=>(a.__todelete==null));
              }
            }
            this.tabler.pagecount=event.lastEventId;
            this.tabler.$emit("onprogress",this.tabler.progress);
          };
        });
      }
    },
    isRowFiltered:function(item,extraFilters){
      if (this.hasfilters==false) return true;
      var toshow=true;
      this.options.columns.map((c)=>{
        let f=this.filters[c.field];
        if ((extraFilters!=null)&&(extraFilters[c.field]!=null))
          f=extraFilters[c.field];
        if ((c.filter)&&(f=="#nodata"))
        {
          if ((item[c.field]!=null)&&(item[c.field].trim()!="")) toshow=false;
        }
        else
        {
          if ((c.filter=="input")&&(f!=null)&&(f.trim()!="")&&((item[c.field]==null)||((item[c.field]!=null)&&(typeof(item[c.field])=="string")&&((item[c.field].trim()=="")||(item[c.field].toLowerCase().search(f.trim().toLowerCase())==-1))))) toshow=false;
          if ((c.filter=="select")&&(f!=null)&&(f!="")&&(item[c.field]!=f)) toshow=false;
          if ((c.filter=="date")&&(f!=null)&&((f.from!=null)&&(f.from!="")&&((item[c.field]===null)||(moment(String(item[c.field])).format("YYYY-MM-DD")<f.from)))) toshow=false;
          if ((c.filter=="date")&&(f!=null)&&((f.to!=null)&&(f.to!="")&&((item[c.field]===null)||(moment(String(item[c.field])).format("YYYY-MM-DD")>f.to)))) toshow=false;
          if ((c.filter=="yesno")&&(f!=null)&&(f=="true")&&(item[c.field]!==true)) toshow=false;
          if ((c.filter=="yesno")&&(f!=null)&&(f=="false")&&(item[c.field]===true)) toshow=false;
        }
      });
      item.__filtered=toshow;
      return toshow;
    },
    allcolumnvalues:function(field)
    {
      var allitems=Array.from(new Set(this.items.map(v=>v[field])));
      return allitems.sort();
    },
    callfunc:function(method){
      if (typeof(method)=="function")
        method(this.itemSelected);
      if (typeof(method)=="string")
        this.$root[method](this.itemSelected);
    },
    countfiltered:function(){
      var c=this.items.filter(d=> d.__filtered).length;
      if ((c==this.items.length)&&(this.filteredcount!=null)) this.filteredcount=null;
      if (this.filteredcount!=c) this.filteredcount=c;
    },
    openContextMenu:function(row,event){
      this.contextSelected=row;
      this.$refs.tablercontext.open(event);
    },
    openTitleContextMenu:function(event){
      this.$refs.titlecontext.open(event);
    },
    refresh:function(){
      this.fetchData(true);
    },
    startloading(){
      this.loading="loading";
    },
    changeSize:function(arr){
      this.resizewidth=arr.width;
      this.$emit("resize",arr);
    },
    setSortField(column){
      if (this.sortfield==column)
        this.sorttype=(this.sorttype==1)?0:1;
      else{
        this.sortfield=column;
        this.sorttype=0;
      }
    },
    sortCompare:function(a,b){
      var field=(this.sortfield==null)?"id":this.sortfield.field;
      let a1=a[field];
      let b1=b[field];
      if (this.sortfield.sortable=="int")
      {
        a1=parseInt(a1);
        b1=parseInt(b1);
      }
      if (this.sortfield.sortable=="float")
      {
        a1=parseFloat(a1);
        b1=parseFloat(b1);
      }
      if ((a1===null)||(a1<b1)) return (this.sorttype!=1)?-1:1;
      if ((b1===null)||(a1>b1)) return (this.sorttype!=1)?1:-1;
      return 0;
    },
    totalsum(column){
      return this.items.reduce((a,b)=>(a + ((isNaN(parseInt(b[column.field])))?0:parseInt(b[column.field]))),0);
    },
    filteredsum(column){
      var c=this.items.filter(d=> d.__filtered);
      return c.reduce((a,b)=>a+parseInt(b[column.field]),0);
    },
    selectNext(e){
      let key=this.options.key;
      let i=this.items.findIndex(i=>((this.itemSelected!=null)&&(i[key]==this.itemSelected[key])));
      if (i==null) return;
      i++;
      let item=this.items[i];
      while ((item)&&(!this.isRowFiltered(item))) {
        i++;
        item=this.items[i];
      }
      if (item) this.selectItem(item);
    },
    selectPrev(e){
      let key=this.options.key;
      let i=this.items.findIndex(i=>((this.itemSelected!=null)&&(i[key]==this.itemSelected[key])));
      if (i==null) return;
      i--;
      let item=this.items[i];
      while ((item)&&(!this.isRowFiltered(item))) {
        i--;
        item=this.items[i];
      }
      if (item) this.selectItem(item);
    },
    handleScroll(e){
//      console.log(e);
    },
    loadMoreItems()
    {
      if (this.dispcount<=this.items.length)
        this.dispcount+=5;
    },
    showContextEditor(){
      this.editorError=null;
      this.showEditor=true;
    },
    saveContextEditor(){
      if (this.sortedcolumns.filter(a=>a.visible).length==0){
        this.editorError="Покажите хотя бы один столбец.";
        return;
      }
      this.visiblecolumns=this.sortedcolumns.filter(a=>a.visible);
      localStorage.setItem("tablercolumns_"+this.options.query,JSON.stringify(this.sortedcolumns));
      this.showEditor=false;
    },
    clearContextEditorCache(){
      localStorage.removeItem("tablercolumns_"+this.options.query);
      this.sortedcolumns=this.options.columns.map(a=>{
        a.visible=true;
        return a;
      });
      this.visiblecolumns=this.sortedcolumns.filter(a=>a.visible);
      this.showEditor=false;
    },
    treeItems(el){
      if (el==null) return [];
      let res=[];
      el.map(a=> {
        res.push(a);
        if (a.children != null) {
          a.children.map(b => {
            b.__parent = a.id;
          });
          a.__expanded=(a.__expanded==null)?(a.isDefaultExpanded===true):a.__expanded;
        }
        this.treeItems(a.children).map(b=>{
          res.push(b);
        });
      });
      return res;
    },
    expandParent(item){
      if (item.__parent==null) return;
      let prow=this.sorteditems.filter(a=>(a.id==item.__parent));
      if (prow.length!=0){
        prow[0].__expanded=true;
        this.expandParent(prow[0]);
      }
    },
    dragClone(original){
      if (this.dragclone===null) return original;
      return this.dragclone(original);
    },
    dragStart(a,b){
      this.$emit("dragstart",{ data:a,event:b });
    },
    dragEnd(a,b){
      this.$emit("dragend",{ data:a,event:b });
    }
  },
  created:function(){
    this.loading='loading';
  },
  mounted:function(){
    let vc=localStorage.getItem("tablercolumns_"+this.options.query);
    if (vc==null){
      this.sortedcolumns=this.options.columns.map(a=>{
        a.visible=true;
        return a;
      });
    }
    else{
      this.sortedcolumns=JSON.parse(vc);
    }
    this.visiblecolumns=this.sortedcolumns.filter(a=>a.visible);
    this.fetchData();
    if (this.tree&&(this.value!=null))
      this.$nextTick(()=>{
        this.expandParent(this.value);
      });
  },
  watch:{
    params: {
      deep:true,
      handler:function(v1,v2){
        if (JSON.stringify(v1)!=JSON.stringify(v2))
        {
          this.loading='loading';
          this.fetchData();
        }
      }
    },
    value: function(value){
      this.itemSelected=value;
      if (value)
      {
        var k='el_'+value.id;
        if ((this.$refs[k]!=null)&&(this.$refs[k][0]!=null))
          this.$refs[k][0].scrollIntoViewIfNeeded(true);
      }
    },
    filters:{
      deep:true,
      handler:function(v){
        this.$nextTick(this.countfiltered);
      }
    }
  },
  components:{
    "context":VueContext,
    "wrapped-component":WrappedComponent,
    "alert":Alert
  },
  directives:{
    infiniteScroll,
  },

}

</script>

<style>
@import '~vue-context/dist/css/vue-context.css';
</style>

<style scoped>
tr[selected] td { background-color: #66CCFF !important }

table[loading]
{
  background-color:"gray";
  opacity:".8";
  filter:blur(2px);
}

div.tablerbuttons {
  right: 20px;
  position: absolute;
}

.tablerfooter {
  background-color:#dff0d8;
  width:var(--width);
  height:30px;
}

.tablersticky {
  position: sticky;
  top: 0;
  z-index:10;
  vertical-align: top;
}

.tablerstickyfilter {
  position: sticky;
  top: 28px;
  z-index:10;
}

span.tblsorticon:not(:hover){
  opacity: 0.33;
}

.datefilter input {
  width:49%;
}

.nooutline {
  outline: none;
}

.scroller {
  height: 100%;
}

div[draggable='true']
{
  width:100%;
  height:100%;
}

tbody tr td {
  height:1px;
  width:1px;
}

.tablerprogresser
{
  position: absolute;
  top:50%;
  left:50%;
  z-index:100001;
}


</style>
